// This file was automatically generated from error.html.
// Please don't edit this file by hand.

goog.provide('el8.template.multiuser_access.error');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.multiuser_access.error.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FormBox el8BoxWithHeading el8FaxFlow mt15p"><img src="/static/images/e-circle-blue.png?v=20160729" style="width:40px;position:absolute;right:25px;top:20px;" /><div class="el8LgSpacer"></div><h2 class="el8BrandColor el8LightWeight el8AlignCenter">Looks like something went wrong!</h2><div class="el8CenterBlock w80p el8AlignCenter"><div class="el8MdSpacer"></div><h4>The server has encountered an unexpected error and cannot complete your request. Please try again.</h4><p>Our engineers have already been alerted, but if you have additional questions about this error, don\'t hesitate to <a href="https://app.elationemr.com/support/">contact us</a>. We apologize for any inconvenience.</p><div class="el8LgSpacer"></div><a href="/efax/" class="el8Btn el8BtnDefault">Back to Home</a><div class="el8LgSpacer"></div></div></div></div>');
  if (!opt_sb) return output.toString();
};
